import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import Header from "./components/Header";
import Home from "./pages/Home";
import Terms from "./pages/T&C/Terms";
import { Toaster } from "sonner";
import IDProof from "./pages/IDProof";
import TamperProof from "./pages/TamperProof";
import FinancialStatement from "./pages/FinancialStatement";
import BounceProof from "./pages/BounceProof";
import ScrollToTop from "./components/ScrollToTop";
import Financial from "./pages/T&C/Finanical";
import AboutUs from "./pages/AboutUs";

// ✅ Component for conditional layout
function Layout({ children }) {
  return (
    <>
      {/* Hide Header on /gff-event */}
      <Header />
      <main style={{ flex: 1 }}>{children}</main>
    </>
  );
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="app-container">
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/id-proof" element={<IDProof />} />
            <Route path="/tamper-proof" element={<TamperProof />} />
            <Route path="/finnalyzer" element={<FinancialStatement />} />
            <Route path="/bounce-proof" element={<BounceProof />} />
            <Route path="/term&condition" element={<Terms />} />
            <Route path="/billing&refunds" element={<Financial />} />
            <Route path="*" element={<Home />} />
          </Routes>
        </Layout>
      </div>

      <Toaster richColors position="top-right" />
    </Router>
  );
}

export default App;

// about us page currently not approved yet
{
  /* <Route path="/aboutus" element={<AboutUs />} />; */
}
